import {
  useCallback,
} from 'react'

import { useShoppingCartContext } from '../../../../../providers/ShoppingCartProvider'
import { urlDecode } from '../../../../../../../helpers'
import generateVehicleParams from '../../../../Items/Item/Details/hooks/generateVehicleParams'
import nrLogger from '../../../../../../../helpers/nrLogger'

const useContinueShopping = () => {
  const {
    shouldShowLoader,
  } = useShoppingCartContext()

  return useCallback(
    (data = null) => {
      // get first OOS item and bring user in serp page using
      // that item detils
      shouldShowLoader(true)
      try {
        const { product, modifiers } = data[0]
        const vehicleParam = generateVehicleParams(modifiers)
        if (__BROWSER__) {
          window.location.href = `/search?q=${urlDecode(product.part.name)}${vehicleParam}`
        }
      } catch (error) {
        nrLogger.error('ShoppingCartV2.useContinueShopping.error', error)
      }
      shouldShowLoader(false)
    },
    [
      shouldShowLoader,
    ],
  )
}

export default useContinueShopping
